module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/MORSE-831cc3ae1c656b4c3a8c0bf5c701e5e8.png";